import React, { useState } from 'lib/react';
import {
  EVGrid, EVPaper, EVTypography, EVButton,
} from '@eagleview/ev-comp-library';
import { useTranslation } from 'lib/translation';
import { useDispatch, useSelector } from 'lib/redux';
import { CUSTOMER_SERVICE_EMAIL } from 'constants/AppConstants';
import { DELETE_ACCOUNT_CLEAR_FAILURE_ERROR } from 'constants/ActionTypes';
import accountsDeletionFaqs from './AccountsDeletion.utils';
import AccountDeletionStyles from './AccountDeletionStyles';
import AccountsDeletionConfirmationDialog from './AccountsDeletionConfirmationDialog';
import deleteAccount from './AccountsDeletion.action';
import AccountDeletionSuccessPage from './AccountDeletionSuccessPage';

function AccountsDeletion() {
  const classes = AccountDeletionStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const accountDeletionFaqsList = accountsDeletionFaqs();
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const handleDeleteDialogClose = () => {
    dispatch({ type: DELETE_ACCOUNT_CLEAR_FAILURE_ERROR });
    setOpenDeleteDialog(false);
  };
  const handleDeleteAccount = () => dispatch(deleteAccount());
  const handleDeleteButton = () => setOpenDeleteDialog(true);
  const { accountDeletionSuccess } = useSelector((state) => state.accountsDeletion);
  if (accountDeletionSuccess) return <AccountDeletionSuccessPage />;
  return (
    <EVPaper className={classes.accountsDeletionPaper}>
      {openDeleteDialog && (
        <AccountsDeletionConfirmationDialog
          open
          handleClose={handleDeleteDialogClose}
          handleDelete={handleDeleteAccount}
        />
      )}
      <EVGrid container className={classes.faqsContainer}>
        {accountDeletionFaqsList.map((faq, index) => (
          <EVGrid
            key={faq.question} // #genai - FAQ questions provide stable list identity.
            item
            id={`faq-${index}`}
            className={classes.faqElement}
          >
            <EVTypography className={classes.faqQuestionText}>{faq.question}</EVTypography>
            <EVTypography className={classes.faqAnswerText}>{faq.answer}</EVTypography>
          </EVGrid>
        ))}
        <EVGrid item className={classes.faqElement}>
          <EVTypography className={classes.faqQuestionText}>{t('account_deletion__compliance_and_add_info')}</EVTypography>
          <EVTypography className={classes.faqAnswerText}>{t('account_deletion__compliance_and_add_info_text')}</EVTypography>
        </EVGrid>
        <EVTypography className={classes.supportText}>
          {t('account_deletion__customer_support_text')}
          {' '}
          <a className={classes.linkText} href={`mailto:${CUSTOMER_SERVICE_EMAIL}`}>{t('common__support_email')}</a>
          {/* #genai Preserve the existing adjacent period while making JSX spacing unambiguous. */}
          <span>.</span>
        </EVTypography>
      </EVGrid>
      <EVButton
        id="deleteBtn"
        variant="contained"
        color="primary"
        className={classes.deleteButton}
        onClick={handleDeleteButton}
      >
        {t('accounts_deletion__delete_account')}
      </EVButton>
    </EVPaper>
  );
}

export default AccountsDeletion;
